// extracted by mini-css-extract-plugin
export default {"nav_outer":"NavHorizontal_nav_outer__Tqzro","nav_tab":"NavHorizontal_nav_tab__uD4nP","nav_link":"NavHorizontal_nav_link__29vEq"};